/**
 * IMPORTS
 */

import { isSameDay, parseISO } from "date-fns";
import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { IRequestShipmentLooseState } from "@/store-zustand/cliente/request-shipment-loose/index.d";

const useRequestShipmentLoose = create<IRequestShipmentLooseState>()(
  persist(
    (set) => ({
      // estados
      dadosRemessa: [],
      selectedZipFile: null,
      selectedFile: null,
      isAvulsa: false,
      remessaAvulsaLimit: [],
      isModalSolicitacaoRemessa: false,
      isOpenTermModal: false,
      dadosResponsabilidade: null,

      // ações
      setDadosRemessa: (dadosRemessa) => set({ dadosRemessa }),
      setSelectedZipFile: (selectedZipFile) => set({ selectedZipFile }),
      setSelectedFile: (selectedFile) => set({ selectedFile }),
      setIsAvulsa: (isAvulsa) => set({ isAvulsa }),
      setMaxAvulsoRequestLimitDia: (remessaAvulsaLimit) => set({ remessaAvulsaLimit }),
      setIsModalSolicitacaoRemessa: (isModalSolicitacaoRemessa) =>
        set({ isModalSolicitacaoRemessa }),
      setIsOpenTermModal: (isOpenTermModal) => set({ isOpenTermModal }),
      setDadosResponsabilidade: (dados) => set({ dadosResponsabilidade: dados }),

      setCleanStateData: () =>
        set({
          dadosRemessa: [],
          selectedZipFile: null,
          selectedFile: null,
          isAvulsa: false,
          isModalSolicitacaoRemessa: false,
          isOpenTermModal: false,
          dadosResponsabilidade: null,
        }),

      clearPersistedData: () =>
        set((state) => {
          const today = new Date();
          const canClear = !state.remessaAvulsaLimit.some((item) =>
            isSameDay(today, parseISO(item.dataCriacao))
          );

          if (!canClear) {
            return {
              dadosRemessa: [],
              selectedZipFile: null,
              selectedFile: null,
              isAvulsa: false,
              isModalSolicitacaoRemessa: false,
              isOpenTermModal: false,
              dadosResponsabilidade: null,
            };
          }

          return {
            dadosRemessa: [],
            selectedZipFile: null,
            selectedFile: null,
            isAvulsa: false,
            remessaAvulsaLimit: [],
            isModalSolicitacaoRemessa: false,
            isOpenTermModal: false,
            dadosResponsabilidade: null,
          };
        }),
    }),
    {
      name: "store-request-shipment-loose",
      partialize: (state) => ({
        remessaAvulsaLimit: state.remessaAvulsaLimit,
      }),
    }
  )
);

/**
 * EXPORTS
 */
export { useRequestShipmentLoose };
